class OrderConfirmationPanelController {
    constructor(shopperService, analyticsService) {
        this.analyticsService = analyticsService;
        this.shopperService = shopperService;
    }

    $onInit() {
        this.status = 'loading';
        const order = this.order ? this.order.Order : {};
        // Todo: unwrap confirmation so that we're just dealing with the order :/
        this.orderCancelled = order.OrderStatus === 'Cancelled';
        if (this.order) {
            this.status = 'orderconfirmation';
        }
        this.analyticsService.push({
            data: {
                order,
                shopper: this.shopperService.shopper,
            },
            type: this.analyticsService.mapperTypes.shop.orderConfirmation,
        });
    }
}

OrderConfirmationPanelController.$inject = ['ShopperService', 'AnalyticsService'];

const orderConfirmationPanelControllerComponentDefinition = {
    bindings: {
        order: '<',
        saveCard: '<',
    },
    controller: OrderConfirmationPanelController,
    template: require('./order-confirmation-panel.component.html').trim(),
};

module.exports = {
    OrderConfirmationPanelController,
    orderConfirmationPanelControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-panel.component.js